// extracted by mini-css-extract-plugin
export var quantityInput = "_fr-0";